/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/volume_on'
export default icon
